// PulseChain — pinned to the top of every network-filter dropdown
// (dashboard + Activity, extension + mobile-web builds).
export const PULSECHAIN_CHAIN_ID = 369n

/**
 * Returns a new array with PulseChain moved to the front, preserving the
 * relative order of every other network. No-op (returns the input) when
 * PulseChain is absent so callers can wrap unconditionally.
 */
export function sortNetworksPulseFirst<T extends { chainId: bigint }>(networks: T[]): T[] {
  const hasPulse = networks.some((n) => n.chainId === PULSECHAIN_CHAIN_ID)
  if (!hasPulse) return networks

  const pulse = networks.filter((n) => n.chainId === PULSECHAIN_CHAIN_ID)
  const rest = networks.filter((n) => n.chainId !== PULSECHAIN_CHAIN_ID)
  return [...pulse, ...rest]
}

// Most-used chains for ZKX users, in display order. Anything not listed keeps
// its original relative order after these.
export const POPULAR_CHAIN_IDS: bigint[] = [
  PULSECHAIN_CHAIN_ID, // PulseChain
  56n, // BNB Smart Chain
  1n, // Ethereum
  8453n, // Base
  42161n, // Arbitrum
  137n, // Polygon
  10n, // OP Mainnet
  43114n // Avalanche
]

/**
 * Returns a new array with the POPULAR_CHAIN_IDS networks first (in that order),
 * followed by every other network in its original relative order.
 */
export function sortNetworksPopularFirst<T extends { chainId: bigint }>(networks: T[]): T[] {
  const rank = (n: T) => {
    const i = POPULAR_CHAIN_IDS.indexOf(n.chainId)
    return i === -1 ? POPULAR_CHAIN_IDS.length : i
  }
  // Array.prototype.sort is stable, so unlisted networks keep their order.
  return [...networks].sort((a, b) => rank(a) - rank(b))
}
